module.exports = {
  TEXT: 'text',
  ATTACHMENT: 'attachment',
  PARTICIPANT: 'participant',
};
